module.exports = __webpack_public_path__ + "img/hex.5f34a2c9.png";